
import Vue from 'vue';

import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  articleCount: number;
}

interface Computed {
  activeArticle: ArticleData;
}

interface Data {
  articleIndex: number;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  props: {
    articleCount: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      articleIndex: 1,
    };
  },

  computed: {
    activeArticle() {
      return this.$store.getters['article/getActiveArticle'];
    },
  },

  watch: {
    activeArticle: {
      handler(article) {
        const id = article && article.id;
        const articlesList = this.$store.getters['article/getCrArticles'];
        const currentArticleIndex = articlesList.indexOf(id) > -1 ? articlesList.indexOf(id) + 2 : 1;
        this.articleIndex = currentArticleIndex;
      },
      immediate: true,
    },
  },
});
